import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available 
        let currentUser = JSON.parse(localStorage.getItem('authData'));
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: currentUser.token,
                    // "Set-Cookie": "HttpOnly;Secure;SameSite=Strict"
                }
            });
        }

        return next.handle(request);
    }
} 


// WEBPACK FOOTER //
// ./src/app/_helpers/token.interceptor.ts